export default "/images/vendor/flag-icon-css/flags/1x1/jp.svg?980c12c54fe2259234344611bde3f6da";